import React from "react"
import CMSRender from "aldoo-ra/CMS/cms-render"
import Typography from "aldoo-ra/Typography"
import Button from "aldoo-ra/Button"

const PricingCard = ({ card }) => {
  const {
    name,
    price,
    duration,
    trial_text,
    cta,
    best_value,
    platforms_text,
    platform_icons,
    plan_features,
  } = card

  return (
    <div
      className={`relative md:w-[390px] lg:w-full max-w-[390px] rounded-[20px] outline-[1px] outline ${
        best_value ? "bg-paper outline-orange_accent" : "bg-paper outline-gray_200 overflow-hidden"
      }`}
    >
      {/* Header Panel */}
      <div
        className={`h-[112px] rounded-t-[20px] py-[36px] ${
          best_value ? "bg-orange_secondary" : "bg-primary_lt/40"
        }`}
      >
        {best_value && (
          <div className="absolute top-[-22px] left-1/2 -translate-x-1/2 bg-gradient_best_value p-[10px] rounded-full">
            <Typography variant="btn1" className="text-white">
              Best Value
            </Typography>
          </div>
        )}
        <Typography 
          variant="h3" 
          className="text-center text-text"
        >
          {name}
        </Typography>
      </div>

      {/* Content */}
      <div className="flex flex-col px-[27px] pt-[44px] pb-[35px]">
        {/* Pricing */}
        <div className="text-center">
          <div className="flex flex-row items-baseline justify-center">
            <Typography 
              component="h3" 
              variant="h2"
              className="text-text"
            >
              {price}
            </Typography>

            <Typography 
              variant="h3" 
              className="text-text ml-1"
            >
              /{duration}
            </Typography>
          </div>
          <Typography 
            variant="body1" 
            className="mt-[42px] mb-[18px]"
          >
            {trial_text}
          </Typography>
        </div>

        {/* CTA Button */}
        <Button
          variant={best_value ? "primary_l" : "secondary_l"}
          className="w-full"
        >
          {cta}
        </Button>

        {/* Platform Availability */}
        <div className="text-center">
          <Typography 
            variant="body1"
            className="text-gray_700 mt-[27px] mb-[20px]"
          >
            {platforms_text}
          </Typography>

          <div className="h-[30px] flex flex-row justify-center items-center gap-[12px] mb-[40px]">
            {platform_icons.map((icon) => (
              <img
                key={icon._id}
                src={icon.image}
                alt={icon.title}
                className="w-[30px] h-[30px] gray_700"
              />
            ))}
          </div>
        </div>

        {/* Features List */}
        <ul className="my-0"> 
          {Array.isArray(plan_features) && plan_features.map((feature, index) => (
            <li key={index} className="flex items-start my-0">
              <Typography 
                variant="body1" 
                className="inline-flex my-[8px]"
              >
                <svg
                  className="w-[24px] h-[24px] text-primary mr-[8px] mt-[4px]"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M5 13l4 4L19 7"
                  />
                </svg>
                <span
                  dangerouslySetInnerHTML={{
                    __html: feature
                      .replace("<b>", '<span class="font-bold">')
                      .replace("</b>", "</span>"),
                  }}
                />
              </Typography>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}

const PricingPlans = () => {
  return (
    <div className="w-full">
      <div className="max-w-[1230px] flex items-center justify-center mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-[60px] md:gap-[50px] lg:gap-4 xl:gap-8 pt-[22px]">
          <CMSRender
            contentType="Pricing Plan"
            renderItem={(card) => <PricingCard key={card._id} card={card} />}
          />
        </div>
      </div>
    </div>
  )
}

export default PricingPlans
